/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Section_AppInputs */

const en_us2_profile_section_app = /** @type {(inputs: Profile_Section_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appearance and language`)
};

const pt_br2_profile_section_app = /** @type {(inputs: Profile_Section_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aparência e idioma`)
};

const es_419_profile_section_app = /** @type {(inputs: Profile_Section_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apariencia e idioma`)
};

const pt_pt2_profile_section_app = /** @type {(inputs: Profile_Section_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aspeto e idioma`)
};

const fr_fr2_profile_section_app = /** @type {(inputs: Profile_Section_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apparence et langue`)
};

const de_de2_profile_section_app = /** @type {(inputs: Profile_Section_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darstellung und Sprache`)
};

const it_it2_profile_section_app = /** @type {(inputs: Profile_Section_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aspetto e lingua`)
};

/**
* | output |
* | --- |
* | "Appearance and language" |
*
* @param {Profile_Section_AppInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_section_app = /** @type {((inputs?: Profile_Section_AppInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Section_AppInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_section_app(inputs)
	if (locale === "es-419") return es_419_profile_section_app(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_section_app(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_section_app(inputs)
	if (locale === "de-DE") return de_de2_profile_section_app(inputs)
	if (locale === "it-IT") return it_it2_profile_section_app(inputs)
	return en_us2_profile_section_app(inputs)
});
export { profile_section_app as "profile.section_app" }